import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { UserProfileService } from '../services/userProfile.service';
import type { UserProfileUpdateInput } from '../types/userProfile.types';
import { toast } from 'sonner';

export function useUserProfile(id?: string) {
 return useQuery({
 queryKey: ['user-profile', id],
 queryFn: () => UserProfileService.getProfile(id!),
 enabled: !!id,
 });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: UserProfileUpdateInput }) => 
      UserProfileService.updateProfile(id, updates),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['user-profile', variables.id] });
    },
    onError: (error: any) => {
      toast.error('Lỗi khi cập nhật hồ sơ: ' + error.message);
    }
  });
}

export function useUploadAvatar() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, companyId, file }: { userId: string; companyId: string; file: File }) => 
      UserProfileService.uploadAvatar(userId, companyId, file),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['user-profile', variables.userId] });
    },
  });
}

export function useUserDevices(userId?: string) {
  return useQuery({
    queryKey: ['user-devices', userId],
    queryFn: () => UserProfileService.getUserDevices(userId!),
    enabled: !!userId,
  });
}

export function useLogoutDevices() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => UserProfileService.logoutAllDevices(userId),
    onSuccess: (_, userId) => {
      queryClient.invalidateQueries({ queryKey: ['user-devices', userId] });
      toast.success('Đã đăng xuất tất cả các thiết bị khác');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi đăng xuất thiết bị: ' + error.message);
    }
  });
}

export function useUpdatePassword() {
  return useMutation({
    mutationFn: ({ current, newPass }: { current: string; newPass: string }) => 
      UserProfileService.updatePassword(current, newPass),
    onSuccess: () => {
      toast.success('Mật khẩu đã được cập nhật thành công!');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Có lỗi xảy ra khi đổi mật khẩu');
    }
  });
}
